import {range, each} from './utils';

export class MusicPlayer {
    constructor(next_url) {
        this.next_url = next_url;
        this.clips = range(2).map(_ => document.createElement('audio'));
    }

    load_clip(clip) {
        clip.src = this.next_url();
        clip.load();
        const idx = this.clips.indexOf(clip);
        console.log(`load[${idx}] = ${clip.src}`);
    }

    start() {
        each(this.clips, c => this.load_clip(c));
        this.service();
    }

    async service() {
        for (let i = 0; i < 2; ++i) {
            const c = this.clips[i];
            const other = this.clips[i^1];

            if (c.ended)
                this.load_clip(c);

            if (!c.paused)
                continue;

            if (!other.paused && (other.currentTime < other.duration - 3.0))
                continue;

            try {
                await c.play();
                console.log(`play[${i}]`);
                break;
            } catch (err) {
                console.log(`error[${i}]: ${err}`);
                this.load_clip(c);
            }
        }

        setTimeout(() => this.service(), 1000);
    }

    set_volume(v) {
        each(this.clips, c => c.volume = v);
    }
}
